import { useEffect, useState } from "react";
import { api } from "./api";
import { logWarn } from "./log";

let cache = null;

export function useAppConfig() {
  const [cfg, setCfg] = useState(cache || { subscriptions_enabled: false });
  useEffect(() => {
    if (cache) return;
    api.get("/config").then((r) => { cache = r.data; setCfg(r.data); }).catch((e) => logWarn("Config non caricata", e));
  }, []);
  return cfg;
}
